<template>
  <details class="filter-facet">
    <summary class="filter-facet__header">
      <div class="filter-facet__title">
        <h3 class="filter-facet__title-text">{{ title }}</h3>
        <div class="filter-facet__arrow"></div>
      </div>
      <div class="filter-facet__selected-tags">
        <span v-for="(tag, index) in checkedItems" :key="index">
          {{ tag }}<template v-if="index !== checkedItems.length - 1">, </template>
        </span>
      </div>
    </summary>
    <ul class="filter-facet__list">
     <template v-for="(facet, f) in facets" :key="f">
        <li v-if="checkFacetTitle(facet.title)" class="filter-facet__list-item">
          <label :for="facet.id" :class="{ '-disabled': facet.disabled || isLoading }">
            <input
              :id="facet.id"
              v-model="checkedItems"
              v-tag:useractionevent.dom="{
                category: category,
                action: 'filter::by needs',
                label: `${title}::${facet.title}`,
                filter_type: 'filter',
                filter_value: `${filterValue.length > 0 ? filterValue : facet.title}`,
                event_name: 'use_filters',
              }"
              type="checkbox"
              :disabled="facet.disabled || isLoading"
              :name="facet.label"
              :value="facet.label"
              @change="
                inputChanged(facet.urlToApiWithParams, facet.urlToShow);
                // Used by OAP CN site
                likecountert();
              "
            />
            <span class="checkmark"></span>
            <span
              class="filter-facet-title"
              :class="{ '-selected': checkedItems.includes(facet.label) }"
            >
              {{ facet.label }}
            </span>
          </label>
        </li>
      </template>
    </ul>
  </details>
</template>

<script>
import { mapGetters } from 'vuex';
import eventBus from '@refapp/eventbus-js';

export default {
  name: 'FilterFacet',
  props: {
    title: {
      type: String,
      default: '',
      required: true,
    },
    facets: {
      type: Array,
      default: () => [],
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lastCount: 0,
      difference: 0,
      operation: 'increase',
      category: window.wsf.AnalyticsVariables.pageCategory
        ? window.wsf.AnalyticsVariables.pageCategory
        : 'content page',
      filterValue: '',
    };
  },
  computed: {
    ...mapGetters('filterList', ['selectedTags', 'selectedBrands']),

    checkedItems() {
      let items = [];

      this.facets.forEach((facet) => {
        this.selectedTags.forEach((tag) => {
          if (tag.title === facet.title) {
            items.push(tag.label);
          }
        });
        this.selectedBrands.forEach((brand) => {
          if (brand.title === facet.title) {
            items.push(brand.title);
          }
        });
      });

      return items;
    },
  },
  methods: {
    inputChanged(urlToApiWithParams, urlToShow) {
      eventBus.emit('filterProducts', {
        apiUrl: urlToApiWithParams,
        url: urlToShow,
      });
    },

    removeActiveClasses() {
      const activeArticles = document.querySelectorAll('.active_like');
      activeArticles.forEach((article) => {
        article.classList.remove('active_like');
      });
    },

    collectArticleIds() {
      const allArticles = document.querySelectorAll('.like__btn');
      allArticles.forEach((article) => {
        this.allitemsArticle.push(article.getAttribute('id'));
      });
      return allArticles;
    },

    applyStoredLikes(articlelike) {
      articlelike.forEach((likedId) => {
        const element = document.getElementById(likedId);
        if (element) {
          element.classList.add('active_like');
        }
      });
    },

    collectFilterValues() {
      const selectedFilterTags = document.querySelectorAll('.-selected');
      const filterValues = [];
      selectedFilterTags.forEach((item) => {
        if (item.control) {
          // TODO: check why item.control doesn't exist (see filter-tags.vue line 76 for reference)
          filterValues.push(item.control.name);
        }
      });
      this.filterValue = filterValues.join('::');
    },

    updateLikeCounts(jsonData) {
      const hideableSections = document.querySelectorAll('.like__btn');
      hideableSections.forEach((section, i) => {
        const allarticleIds = section.getAttribute('id');
        const likeCount = jsonData.list[i].likeCount;
        const likeNumberElement = document
          .getElementById(allarticleIds)
          .getElementsByClassName('like__number')[0];
        likeNumberElement.innerHTML = likeCount > 0 ? likeCount : '';
      });
    },

    // Used by OAP CN site
    likecountert() {
      setTimeout(() => {
        this.removeActiveClasses();
        this.collectArticleIds();

        const articlelike = JSON.parse(localStorage.getItem('articlelike'));
        if (articlelike && articlelike.length > 0) {
          this.applyStoredLikes(articlelike);
        }

        this.collectFilterValues();

        fetch(`/api/sitecore/article/GetLikeCountList?&idList=${this.allitemsArticle}`)
          .then((response) => response.json())
          .then((jsonData) => this.updateLikeCounts(jsonData))
          .catch((e) => console.error(e));
      }, 2599);
    },

    checkFacetTitle(facetTitle) {
      const uuidRegexp = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
      const isUUID = uuidRegexp.test(facetTitle);

      return !isUUID;
    },
  },
};
</script>
